import {railStates} from './../ukrail-routes';
import {outOfPolicyStatus} from '../../common/enum/out-of-policy-status-enum';

export default function EuropeanRailsResultController(
    $scope,
    railsFactory,
    basketService,
    cultureService,
    l10nService,
    $stateParams,
    $state,
    $filter,
    railAmendmentService,
) {
    'ngInject';

    $scope.isReturnSelection = !!$stateParams.outwardSelection;
    $scope.selectedOutwardAlternative = $scope.isReturnSelection ? $stateParams.outwardSelection.selectedAlternative : null;
    $scope.cultureService = cultureService;
    $scope.selectedAlternatives = null;
    $scope.selectedAlternative = null;
    $scope.selectedJourney = null;
    $scope.searchId = $scope.isReturnSelection ? $stateParams.outwardSelection.searchId : null;

    const segment = railsFactory.params.RailTicketSearchSegments[0];
    const searchOrigin = $scope.isReturnSelection ? segment._arrival.DisplayString : segment._departure.DisplayString;
    const searchDestination = $scope.isReturnSelection ? segment._departure.DisplayString : segment._arrival.DisplayString;

    let rails;
    prepareSearchResults();

    function stringFormat() {
        const args = arguments;

        return args[0].replace(/{(\d+)}/g, function(match, number) {
            const index = parseInt(number) + 1;
            return typeof args[index] !== 'undefined' ? args[index] : match;
        });
    }

    function getModel(alternative, journey) {
        return journey.Legs.map((leg) => {
            const groupedFares = _.groupBy(alternative.Fares.filter((fare) => fare.FareLegs.find((fareLeg) => fareLeg.LegId === leg.Id)),
                (fare) => fare.FareTypeId
            );

            const fares = _.map(groupedFares,
                (value, key) => ({
                        count: value.length,
                        type: rails.FareTypes[key],
                        comfortOption: rails.ComfortOptions[value[0].FareLegs.find((fareLeg) => fareLeg.LegId === leg.Id).ComfortClassId],
                    })
            );

            const extras = alternative.IncludedExtras
                .filter((extra) => extra.LegIds.find((extraLeg) => extraLeg === leg.Id))
                .map((extra) => extra.Description);

            return Object.assign({fares, extras}, leg);
        });
    }

    function prepareItems(journeys) {
        const groupedByDate = _.groupBy(journeys, (journey) => $filter('date')(journey.DepartAt, 'dd MMM yyyy'));
        const items = new Array();

        for (const date of Object.keys(groupedByDate)) {
            items.push({dateHeader: true, date});
            for (const journey of groupedByDate[date]) {
                items.push(journey);

                for (const alternative of journey.FirstClassAlternatives) {
                    alternative.legs = getModel(alternative, journey);
                }
                for (const alternative of journey.StandardClassAlternatives) {
                    alternative.legs = getModel(alternative, journey);
                }
            }
        }

        return items;
    }

    $scope.getSearchOriginDistanceWarning = function(selectedJourney) {
        const template = l10nService.localize('This train departs from <b>{0}</b>, which is <b>{1} km</b> away from <b>{2}</b>. We show you this to give you more choice');

        return stringFormat(template, selectedJourney.Legs[0].OriginStation, selectedJourney.SearchOriginDistanceWarning.Distance.toFixed(2), searchOrigin);
    };

    $scope.getSearchDestinationDistanceWarning = function(selectedJourney) {
        const template = l10nService.localize('This train arrives to <b>{0}</b>, which is <b>{1} km</b> away from <b>{2}</b>. We show you this to give you more choice');

        return stringFormat(template, selectedJourney.Legs[selectedJourney.Legs.length - 1].DestinationStation, selectedJourney.SearchDestinationDistanceWarning.Distance.toFixed(2), searchDestination);
    };
    $scope.isBasketDisabled = function(status) {
        return status === outOfPolicyStatus.OutOfPolicyBookingProhibited;
    };
    $scope.isOutOfPolicyWarning = function(status) {
        if (status === outOfPolicyStatus.InPolicyWithWarning || status === outOfPolicyStatus.InPolicyWithWarningAndJustification) {
            return true;
        }
        return false;
    };
    $scope.tooltipEnabled = function(i) {
        return cultureService.getCurrencySign(i.StandardClassAlternatives[0].Currency) !== '€' || cultureService.getCurrencySign(i.FirstClassAlternatives[0].Currency) !== '€';
    };

    $scope.otherTooltipEnabled = function(i) {
        return cultureService.getCurrencySign(i.Currency) !== '€';
    };

    $scope.standardEuroPrice = function(i) {
        return ' ' + '€' + (i.StandardClassAlternatives[0].PriceInEuro / 100).toFixed(2);
    };

    $scope.otherEuroPrice = function(i) {
        return ' ' + '€' + (i.PriceInEuro / 100).toFixed(2);
    };

    $scope.firstClassEuroPrice = function(i) {
        return ' ' + '€' + (i.FirstClassAlternatives[0].PriceInEuro / 100).toFixed(2);
    };

    $scope.firstClassMinPrice = function(i) {
        return ' ' + cultureService.getCurrencySign(i.FirstClassAlternatives[0].Currency) + (i.FirstClassAlternatives[0].Price / 100).toFixed(2);
    };

    $scope.standardClassMinPrice = function(i) {
        return ' ' + cultureService.getCurrencySign(i.StandardClassAlternatives[0].Currency) + (i.StandardClassAlternatives[0].Price / 100).toFixed(2);
    };

    $scope.isRedWarningVisible = function(alternatives) {
      return _.every(alternatives, function(al) {
                return al.OutOfPolicyStatus === outOfPolicyStatus.OutOfPolicyBookingProhibited
                    || al.OutOfPolicyStatus === outOfPolicyStatus.OutOfPolicyBookingAllowed
                    || al.OutOfPolicyStatus === outOfPolicyStatus.OutOfPolicyBookingAllowedWithJustification;
        });
    };

    $scope.isYellowWarningVisible = function(alternatives) {
        return _.every(alternatives, function(al) {
            return al.OutOfPolicyStatus === outOfPolicyStatus.InPolicyWithWarningAndJustification
                || al.OutOfPolicyStatus === outOfPolicyStatus.InPolicyWithWarning;
        });
    };

    $scope.openTab = function(alternativeId) {
        $scope.selectedAlternative = $scope.selectedAlternatives.find((alternative) => alternative.Id === alternativeId);

        colorizeButtons('tablinks', 'tablink_' + alternativeId);

        const tabcontent = document.getElementsByClassName('tabcontent');
        for (const tab of tabcontent) {
            tab.style.display = 'none';
        }
        const tabId = 'tab_' + alternativeId;
        document.getElementById(tabId).style.display = 'block';
    };

    $scope.selectStandardClass = function(journey) {
        $scope.selectedAlternatives = journey.StandardClassAlternatives;
        $scope.selectedAlternative = $scope.selectedAlternatives[0];
        $scope.selectedJourney = journey;

        colorizeButtons('price-alternative-btn', 'button_standard_' + journey.Id);
    };

    $scope.selectFirstClass = function(journey) {
        $scope.selectedAlternatives = journey.FirstClassAlternatives;
        $scope.selectedAlternative = $scope.selectedAlternatives[0];
        $scope.selectedJourney = journey;

        colorizeButtons('price-alternative-btn', 'button_first_' + journey.Id);
    };

    function colorizeButtons(groupClass, buttonId) {
        const buttons = document.getElementsByClassName(groupClass);
        for (const el of buttons) {
            angular.element(el).removeClass('btn-selected');
        }

        angular.element(document.getElementById(buttonId)).addClass('btn-selected');
    }

    $scope.continueToNextStep = function() {
        if ($stateParams.rebook) {
            const tripId = $stateParams.rebook.tripId;

            const journeyId = $scope. selectedJourney.Id;
            const alternativeIds = $scope.selectedAlternative.Ids;

            railAmendmentService.createEuRailRebookCandidate({journeyId, alternativeIds}, $stateParams.rebook)
                .then((recommendationId) => {
                    railAmendmentService.navigateToCheckoutWithNewRailGroup(recommendationId, tripId);
                });
        } else if ($scope.isReturnSelection || railsFactory.params.ReturnOrSingleJourney === 'S') {
            addToBasket();
        } else {
            searchInward();
        }
    };

    function addToBasket() {
        const journeys = new Array();
        const outwardJourney = $scope.isReturnSelection ? $stateParams.outwardSelection.selectedJourney : $scope.selectedJourney;
        const outwardAlternative = $scope.isReturnSelection ? $stateParams.outwardSelection.selectedAlternative : $scope.selectedAlternative;
        const returnJourney = $scope.isReturnSelection ? $scope.selectedJourney : null;
        const returnAlternative = $scope.isReturnSelection ? $scope.selectedAlternative : null;

        journeys[0] = toBasketJourney(outwardJourney, outwardAlternative);
        if (returnJourney) {
            journeys[1] = toBasketJourney(returnJourney, returnAlternative);
        }

        const basketRail = {
            price: ($scope.selectedAlternative.Price + ($scope.isReturnSelection ? $stateParams.outwardSelection.selectedAlternative.Price : 0)) / 100,
            outwardJourney,
            returnJourney,
            outwardAlternative,
            returnAlternative,
            seats: parseInt(railsFactory.params.Travelers.Adult.value, 10),
            searchId: $scope.searchId,
            journeys,
        };

        basketService.addEuRail(basketRail);
    }

    function toBasketJourney(searchJourney, searchAlternative) {
        const travelClass = searchJourney.StandardClassAlternatives.find((alt) => alt.Id === searchAlternative.Id) ? 'Standard' : 'First';

        return {
            departAt: searchJourney.DepartAt,
            arriveAt: searchJourney.ArriveAt,
            diffDays: moment(searchJourney.ArriveAt).diff(moment(searchJourney.DepartAt), 'days'),
            originStation: searchJourney.Legs[0].OriginStation,
            destinationStation: _.last(searchJourney.Legs).DestinationStation,
            travelClass,
        };
    }

    function searchInward() {
        const outwardSelection = {
            selectedJourney: $scope.selectedJourney,
            selectedAlternative: $scope.selectedAlternative,
            searchId: $scope.searchId,
        };

        railsFactory.fetchInwardEuRails($scope.selectedJourney.Id, $scope.selectedAlternative.Ids, $scope.searchId)
            .then(() => $state.go(railStates.EUROPEANRESULTSINWARD, {outwardSelection}));
    }

    $scope.earlierPage = function() {
        railsFactory.fetchPageEuRails($scope.pageId, 'Previous', getSearchDirection(), $scope.searchId, !!$stateParams.rebook)
            .then(() => prepareSearchResults());
    };

    $scope.laterPage = function() {
        railsFactory.fetchPageEuRails($scope.pageId, 'Next', getSearchDirection(), $scope.searchId, !!$stateParams.rebook)
            .then(() => prepareSearchResults());
    };

    function prepareSearchResults() {
        rails = railsFactory.getFlights();
        $scope.pageId = rails.PageId;
        $scope.searchResultItems = prepareItems(rails.Journeys);
        $scope.earlierButtonDisabled = !rails.PreviousLinkEnabled;
        $scope.laterButtonDisabled = !rails.NextLinkEnabled;

        $scope.selectedAlternatives = null;
        $scope.selectedAlternative = null;
        $scope.selectedJourney = null;

        if (rails.SearchId) {
            $scope.searchId = rails.SearchId;
        }
    }

    function getSearchDirection() {
        return $scope.isReturnSelection ? 'Inward' : 'Outward';
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/controllers/europeanRailsResultCtrl.js